export default __webpack_public_path__ + "static/media/pic_ai_2.674a94ca.png";